module.exports = __webpack_public_path__ + "static/media/StepguideSpiderSEA.bf7147b6.PNG";